<template>
    <div class="wb-sidebar-menu-line">
        <div></div>
        <div class="wb-dnd-on-hover-anchor">
            <SVGDragNDrop class="wb-dnd-on-hover-visible"/>
        </div>
    </div>
</template>

<script>
import SVGDragNDrop from '@/UI/Components/SVG/SVGDragNDrop.vue';

export default {
    name: 'SidebarMenuItemBot5',
    components: { SVGDragNDrop },
};
</script>

<style scoped lang="scss">
@import "CSS/fonts.scss";
@import "CSS/colors.scss";
@import "CSS/animations.scss";
@import "CSS/common.scss";

.wb-sidebar-menu-line {
    display: grid;
    grid-template-columns: auto max-content;
    grid-column-gap: 8px;
    width: 100%;
}

.wb-dnd-on-hover-anchor {
    width: 0;
}

.wb-dnd-on-hover-visible {
    //display: none;
    position: relative;
    right: 24px;
    color: transparent;
    @include button-smooth;
}

.wb-sidebar-menu-item:hover .wb-dnd-on-hover-visible{
    color: $green2;
}

</style>